import { FEEDBACK_MODEL_CLASS_NAME } from '../../../../models/feedback/constants'
import afterCreateFeedbackHook from '../../../../models/feedback/hooks/after-create'
import { afterUpdateProfileHook } from '../../../../models/profile/hooks/after-update'
import afterCreateWorkoutExerciseHook from '../../../workout-exercise/model/hooks/after-create'
import { afterCreateWorkoutHook } from '../../../../modules/workout/model/hooks/after-create'
import { EXERCISE_CLASS_NAME } from '../../../exercise/model/constants'
import { PROFILE_CLASS_NAME } from '../../../../models/profile/constants'
import getClassNameReduxUtil from '../../utils/get-class-name'
import { WORKOUT_CLASS_NAME } from '../../../workout/model/constants'
import { WORKOUT_EXERCISE_CLASS_NAME } from '../../../workout-exercise/model/constants'
import { afterCreateExerciseHook } from '../../../exercise/model/hooks'
import { EXERCISE_LOG_CLASS_NAME } from '../../../exercise-log/model/constants'
import { afterCreateExerciseLogHook } from '../../../exercise-log/model/hooks'
import { EXERCISE_LOG_SUMMARY_CLASS_NAME } from '../../../exercise-log-summary/model/constants'
import { afterCreateExerciseLogSummaryHook } from '../../../exercise-log-summary/model/hooks'

const CLASS_NAME_TO_FUNCTION = {
  [FEEDBACK_MODEL_CLASS_NAME]: afterCreateFeedbackHook,
  [EXERCISE_CLASS_NAME]: afterCreateExerciseHook,
  [EXERCISE_LOG_CLASS_NAME]: afterCreateExerciseLogHook,
  [EXERCISE_LOG_SUMMARY_CLASS_NAME]: afterCreateExerciseLogSummaryHook,
  [PROFILE_CLASS_NAME]: afterUpdateProfileHook,
  [WORKOUT_CLASS_NAME]: afterCreateWorkoutHook,
  [WORKOUT_EXERCISE_CLASS_NAME]: afterCreateWorkoutExerciseHook
}

function afterCreateReduxHook (instance, state, dispatch) {
  const className = getClassNameReduxUtil(instance)
  const fn = CLASS_NAME_TO_FUNCTION[className]
  if (!fn) {
    return state
  }
  return fn(instance, state, dispatch)
}

export default afterCreateReduxHook
